import React from 'react';
import { Spin, Typography } from 'antd';
import { DashboardPageShell, DashboardPanel } from '../dashboard';
import '../dashboard/dashboardFleet.css';

export function MaintenancePageFrame({ title, subtitle, mobileHelperText, showMobileHelperText = false, loading, children, shellTitle, renderHeaderActions, panelActions }) {
  return (
    <DashboardPageShell
      title={shellTitle}
      contentClassName="dashboard-fleet-page maintenance-dashboard-page"
      headerClassName="dashboard-fleet-header"
      productDashboardShell="customer"
      renderHeaderActions={renderHeaderActions}
    >
      <DashboardPanel className="dashboard-fleet-dashboard-panel">
        <div className="dashboard-fleet-section-heading maintenance-panel-heading">
          <div className="maintenance-panel-heading-copy">
            <Typography.Title level={3}>{title}</Typography.Title>
            <Typography.Text type="secondary" className="dashboard-fleet-helper-text">
              {subtitle}
            </Typography.Text>
            {showMobileHelperText && mobileHelperText ? (
              <Typography.Text type="secondary" className="dashboard-fleet-helper-text maintenance-mobile-helper-text">
                {mobileHelperText}
              </Typography.Text>
            ) : null}
          </div>
          {panelActions ? <div className="maintenance-panel-heading-actions">{panelActions}</div> : null}
        </div>

        <Spin spinning={loading}>
          <div className="maintenance-page-content">{children}</div>
        </Spin>
      </DashboardPanel>
    </DashboardPageShell>
  );
}

export function MaintenanceTabs({ activeTab, onChange, hideOnMobileRecordsOpen = false }) {
  const tabs = [
    { key: 'ACTIVE', label: 'Active Forklifts' },
    { key: 'RETIRED', label: 'Retired Forklifts' },
  ];

  return (
    <div className={`maintenance-tabs-wrap${hideOnMobileRecordsOpen ? ' maintenance-tabs-wrap-mobile-hidden' : ''}`}>
      <div className="fleet-toggle maintenance-tabs" role="tablist" aria-label="Maintenance view">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className="fleet-toggle-button"
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
